<template>
    <div class="">
        <div class="flex flex-col items-center gap-4 pb-20">
            <div
                class="mb-8 mt-44 flex flex-col items-center justify-center gap-10 text-center"
            >
                <h1 class="font-sans text-4xl md:text-6xl">Contact Us</h1>
                <div class="max-w-[500px] text-center font-300 text-xl">
                    Whether you need assistance with booking, have questions
                    about your trip, or need help with any aspect of our
                    platform, our support team is here to help.
                </div>
            </div>
            <NuxtLink
                :href="`mailto:${config.public.contactEmail}`"
                class="underline hover:text-neutral-900"
                ><AButton>Get in touch</AButton>
            </NuxtLink>
            <div
                class="mt-16 flex w-screen flex-col items-center justify-center bg-neutral-100 p-6 md:p-8"
            >
                <div class="w-full max-w-page px-0">
                    <h1 class="mb-8 mt-12 w-full font-400 text-2xl">
                        How can we help you?
                    </h1>
                    <div
                        class="grid w-full grid-cols-none justify-center gap-6 md:w-fit md:grid-cols-2 lg:grid-cols-3"
                    >
                        <SquaredInfoCard
                            v-for="cardContent in infoCardsContent"
                            :key="cardContent.title"
                            :icon="cardContent.icon"
                            :title="cardContent.title"
                            :body="cardContent.content"
                            variant="light"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full max-w-page px-6">
                <h1 class="mb-8 mt-12 w-full text-left font-400 text-2xl">
                    How can you contact us?
                </h1>
                <div
                    class="font-300 text-base text-neutral-700 md:max-w-[450px]"
                >
                    Just send us an email at
                    <NuxtLink
                        :href="`mailto:${config.public.contactEmail}`"
                        class="underline hover:text-neutral-900"
                        >{{ config.public.contactEmail }}</NuxtLink
                    >, and someone from our team will get back to you in up to
                    24h.
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const config = useRuntimeConfig()
const infoCardsContent = computed(() => {
    return [
        {
            icon: 'suitcase',
            title: 'Booking Assistance',
            content:
                'Need help making a reservation or managing an existing booking? Our team can guide you through the process and ensure everything is set for your trip.',
        },
        {
            icon: 'question',
            title: 'FAQs',
            content:
                'We can answer any quick questions you might have to common topics like our platform, booking policies, and tips for choosing a hotel.',
        },
        {
            icon: 'desktop',
            title: 'Account Management',
            content:
                'If you have questions about your Ascend account, including login issues, profile updates, or preferences, we’re here to assist.',
        },
        {
            icon: 'dotsMessage',
            title: 'Special Requests',
            content:
                'Have special requirements or requests for your trip? Let us know, and we’ll do our best to accommodate your needs.',
        },
        {
            icon: 'wrench',
            title: 'Technical Support',
            content:
                'Experiencing technical difficulties with our website or app? Our technical support team is on standby to resolve any issues.',
        },
    ]
})
</script>
